export default __webpack_public_path__ + "static/media/930.d600ab46.gif";